<template>
  <div>
    <a-modal
      title="手动邀请"
      class="single-invite-modal"
      :visible="visible"
      :maskClosable="false"
      @cancel="handleCancel"
      width="580px"
    >
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item ref="name" label="姓名" prop="name">
          <a-input
            v-model.trim="form.name"
            @blur="
              () => {
                $refs.name.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item label="电话" prop="phone" ref="phone">
          <a-input-group>
            <a-row :gutter="8">
              <a-col :span="5">
                <a-input
                  @blur="
                    () => {
                      $refs.phone.onFieldBlur();
                    }
                  "
                  v-model.trim="form.countryCode"
                  placeholder="国家码"
                />
              </a-col>
              <a-col :span="4">
                <a-input
                  @blur="
                    () => {
                      $refs.phone.onFieldBlur();
                    }
                  "
                  v-model.trim="form.areaCode"
                  placeholder="区号"
                />
              </a-col>
              <a-col :span="10">
                <a-input
                  v-model.trim="form.phone"
                  @blur="
                    () => {
                      $refs.phone.onFieldBlur();
                    }
                  "
                  @change="
                    () => {
                      $refs.phone.onFieldChange();
                    }
                  "
                  placeholder="座机/手机号"
                />
              </a-col>
              <a-col :span="5">
                <a-input
                  @blur="
                    () => {
                      $refs.phone.onFieldBlur();
                    }
                  "
                  v-model.trim="form.ext"
                  placeholder="分机号"
                />
              </a-col>
            </a-row>
          </a-input-group>
        </a-form-model-item>
        <a-form-model-item label="身份" prop="identity">
          <a-radio-group v-model="form.identity">
            <a-radio v-for="item of roleArr" :key="item.key" :value="item.key">
              {{ item.name }}
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <div>
          <a-button
            class="add-button"
            :disabled="addButtonDisabled"
            :loading="addButtonLoading"
            @click="onAdd"
          >
            添加至参会列表
          </a-button>
          <a-button
            :disabled="callButtonDisabled"
            :loading="callButtonLoading"
            style="margin-left: 10px"
            type="primary"
            @click="onCall"
          >
            立即外呼
          </a-button>
        </div>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { getRoleList } from "@/model/conf/model";
import { mapState, mapGetters } from "vuex";
import { callOut, addOtherParty } from "@/services/conf";

// import { buildAcmPhone } from "@/utils/validator";

import { isChinaCellPhone, regNumber, regTel } from "@/utils/validator";

export default {
  props: {
    visible: {
      require: true,
      type: Boolean
    },
    meeting: {
      require: true,
      type: Object
    }
  },
  data() {
    return {
      CONF_BAIYING_ROLE_LIST: getRoleList(),
      buttonLoading: false,
      addButtonLoading: false,
      callButtonLoading: false,
      features: {
        type: "",
        roleList: [],
        saveContact: false,
        companyType: false,
        company: false
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        name: "",
        countryCode: "",
        areaCode: "",
        phone: "",
        ext: "",
        identity: undefined,
        company: "",
        type: undefined,
        department: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "长度1到50个字",
            trigger: "blur"
          },
          {
            validator: this.validatorName,
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: "请输入电话号码",
            trigger: "change"
          },
          {
            min: 6,
            max: 16,
            message: "电话/手机长度必须在6~16个字符内",
            trigger: "blur"
          },
          {
            required: true,
            message: "请输入电话号码",
            trigger: "blur"
          },
          {
            validator: this.validatorPhone,
            trigger: "blur"
          }
        ],
        identity: [
          {
            required: true,
            message: "请选择身份",
            trigger: "change"
          }
        ],
        company: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: "blur"
          }
        ],
        department: [
          {
            required: true,
            message: "请输入部门名称",
            trigger: "blur"
          }
        ]
        /* type: [
          {
            required: true,
            message: "Please select Activity zone",
            trigger: "change"
          }
        ] */
      }
    };
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.resetFields();
          this.form.countryCode = "";
          this.form.areaCode = "";
          this.form.ext = "";
        }
      }
      // 初始化数据
    }
  },
  mounted() {
    this.initConfType();
  },
  computed: {
    ...mapState(["auth"]),
    ...mapGetters(["roleArr", "dialoutAllowed"]),
    addButtonDisabled() {
      return this.callButtonLoading;
    },
    callButtonDisabled() {
      return this.addButtonLoading;
    },
    summit() {
      return this.$store.getters.meetingInfo.bridgeName;
    }
  },
  methods: {
    initConfType() {
      if (this.$store.getters.isByConf) {
        this.features.roleList = getRoleList();
      } else if (this.$store.getters.isZhConf) {
        this.features.roleList = getRoleList();
      }
    },
    handleCancel() {
      this.$emit("cancel");
    },
    validatorName(rule, value, callback) {
      // eslint-disable-next-line no-useless-escape
      // let regExp = /[~,',‘,’,”,",“,#,\\,\,]+/;
      let regExp = /^[\u4e00-\u9fa5_a-zA-Z0-9-\s()[\]]+$/;
      if (!regExp.test(value)) {
        callback(new Error("姓名不能包含特殊字符，仅支持中文英文数字。"));
      } else {
        callback();
      }
    },
    validatorPhone(rule, value, callback) {
      // 电话第一位不能是0

      if (
        regNumber(this.form.countryCode) &&
        regNumber(this.form.areaCode) &&
        regNumber(this.form.phone) &&
        regNumber(this.form.ext)
      ) {
        const countryCode = this.form.countryCode || "86";

        if (isChinaCellPhone(countryCode, this.form.phone)) {
          callback();
        } else {
          if (!regTel(this.form.phone)) {
            callback(new Error("电话号码格式不正确，第一位不能为0"));
          } else {
            // 匹配第一位为0
            if ("" === this.form.areaCode) {
              callback(new Error("请输入区号"));
            } else {
              callback();
            }
          }
        }
        // } else {
        //   // 验证号码是否跟已参会人重复
        //   callback(new Error("电话号码不能跟已参会人员相同"));
        // }
      } else {
        callback(new Error("只能输入数字"));
      }
    },
    submitInfo(cb) {
      return this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const phone =
            this.form.phone + ("" !== this.form.ext ? "-" + this.form.ext : "");
          const summit = this.summit;
          const countryCode = this.form.countryCode || "86";
          let param = {
            phone,
            summit,
            name: this.form.name,
            role: this.form.identity,
            countryCode,
            areaCode: this.form.areaCode,
            company: this.form.company,
            department: this.form.department
          };
          return cb(param);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onAdd() {
      this.submitInfo(submitInfo => {
        if (submitInfo) {
          this.addButtonLoading = true;
          addOtherParty(this.summit, [submitInfo])
            .then(() => {
              this.$message.success("添加中...");
              this.addButtonLoading = false;
              this.handleCancel();
            })
            .catch(err => {
              this.addButtonLoading = false;
              this.$message.error("添加失败。");
              console.log(err);
            });
        }
      });
    },
    onCall() {
      if (!this.dialoutAllowed) {
        // 提示没有外呼权限
        this.$info({
          title: "提示",
          // JSX support
          content: <div> 您没有外呼权限 </div>
        });
        this.$refs.contactModel.$emit("contact-model-call-error");
      } else {
        this.submitInfo(submitInfo => {
          if (submitInfo) {
            this.callButtonLoading = true;
            callOut(submitInfo)
              .then(() => {
                // extracode 为1代表该参会人已入会
                try {
                  // const showPhone = buildAcmPhone(
                  //   submitInfo.countryCode,
                  //   submitInfo.areaCode,
                  //   submitInfo.phone
                  // );
                  // const callOutParty = {
                  //   name: submitInfo.name,
                  //   role: submitInfo.role,
                  //   countryCode: submitInfo.countryCode,
                  //   areaCode: submitInfo.areaCode,
                  //   phone: submitInfo.phone,
                  //   showPhone,
                  //   disconnectReason: 0,
                  //   status: 2
                  // };
                  // this.$eventHub.$emit("call-out-party", [callOutParty]);
                  // 更新数据正在连接
                } catch (e) {
                  console.log(e);
                }
                this.$message.success("外呼中...");
                this.callButtonLoading = false;
                this.handleCancel();
              })
              .catch(err => {
                this.$message.error("外呼失败");
                this.callButtonLoading = false;
                console.log(err);
              });
          }
        });
      }
    }
  }
};
</script>

<style lang="less">
.single-invite-modal {
  .single-invite-content {
  }
  .ant-modal-header {
    border-bottom: 0;
  }
  .ant-modal-footer {
    border-top: 0;
    padding-bottom: 25px;
    padding-right: 30px;
    .add-button {
      background: #fff;
      border: solid 1px #e5e5e5;
      // border-radius: 0;
      font-size: 13px;
      height: 32px;
      color: #333333;

      &:focus {
        outline: none;
        color: #333333;
        border-color: #e5e5e5;
      }

      &:after {
        border: 0 none;
        opacity: 0;
        animation: none 0 ease 0 1 normal;
      }

      &:hover {
        outline: none;
        border: solid 1px rgba(0, 0, 0, 0.4);
        background-color: rgba(255, 255, 255, 0.8);
        color: #333333;
      }

      &:active {
        color: #333333;
        border: solid 1px rgba(0, 0, 0, 0.4);
        background-color: rgba(0, 0, 0, 0.3);
      }

      &:disabled {
        border-color: #d9d9d9 !important;
        color: rgba(0, 0, 0, 0.25) !important;
        background-color: #f5f5f5 !important;
        text-shadow: none !important;
        box-shadow: none !important;
      }
    }
  }
}
</style>
